<div class="d-flex">
  <vitamui-title-breadcrumb [data]="breadCrumbData">
    <h5>Titre de mon application</h5>
  </vitamui-title-breadcrumb>
</div>
